/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import styled, { css } from 'styled-components';
import CheckIconAlt from '@src/svgs/CheckIconAlt';
import { GoalOption } from './GoalSelector';

interface GoalFilterComponentProps {
  goals: GoalOption[];
  selectedGoal: GoalOption | null;
  setSelectedGoal: (goal: GoalOption | null) => void;
  useGoalFilter: boolean;
  setUseGoalFilter: (useFilter: boolean | ((prev: boolean) => boolean)) => void;
  allowNone?: boolean;
  title?: string;
  align?: 'center' | 'left';
}

const GoalFilterComponent: React.FC<GoalFilterComponentProps> = ({
  goals,
  selectedGoal,
  setSelectedGoal,
  useGoalFilter,
  setUseGoalFilter,
  allowNone = true,
  title = 'Target Goal',
  align = 'center',
}) => {
  const handleGoalClick = (goal: GoalOption) => {
    // If clicking the already selected goal, deselect it (if allowNone is true)
    if (selectedGoal?.id === goal.id && allowNone) {
      setSelectedGoal(null);
    } else {
      setSelectedGoal(goal);
    }
  };

  return (
    <GoalFilterSection>
      <CheckBoxContainer
        onClick={() => setUseGoalFilter(prev => !prev)}
        disabled={goals.length === 0}
        align={align}
      >
        <CheckBox isChecked={useGoalFilter} role="button">
          {useGoalFilter && <CheckIconAlt />}
        </CheckBox>
        <div className="checkbox-text">{title}</div>
      </CheckBoxContainer>

      {useGoalFilter && goals.length > 0 && (
        <GoalGrid>
          {goals.map(goal => {
            const isSelected = selectedGoal?.id === goal.id;
            return (
              <GoalItem
                key={goal.id}
                selected={isSelected}
                onClick={() => handleGoalClick(goal)}
              >
                <GoalLabel>{goal.label}</GoalLabel>
                <GoalCheckmark selected={isSelected}>
                  {isSelected && '✓'}
                </GoalCheckmark>
              </GoalItem>
            );
          })}
        </GoalGrid>
      )}
    </GoalFilterSection>
  );
};

export default GoalFilterComponent;

// Styled components
const GoalFilterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CheckBoxContainer = styled.div<{
  disabled: boolean;
  align: 'center' | 'left';
}>`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align};
  gap: 8px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};

  .checkbox-text {
    color: #f3e9d7;
    font-size: 12px;
    line-height: 140%;
    text-align: ${props => props.align};
  }
`;

const CheckBox = styled.div<{ isChecked: boolean }>`
  background-color: ${props => (props.isChecked ? '#4AD067' : 'transparent')};
  width: 16px;
  height: 16px;
  border-radius: 2px;
  overflow: hidden;
  border: ${props => (props.isChecked ? 'none' : '1px solid #9B9B9B')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

const GoalGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  width: 100%;
  margin-top: 8px;
`;

const GoalItem = styled.div<{ selected: boolean }>`
  padding: 8px;
  position: relative;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid ${props => (props.selected ? '#f2d093' : '#5d5d5d')};
  background-color: ${props =>
    props.selected ? 'rgba(242, 208, 147, 0.1)' : 'transparent'};
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    border-color: #f2d093;
  }
`;

const GoalLabel = styled.span`
  color: #f3e9d7;
  font-size: 10px;
  font-weight: 500;
  line-height: 150%;
  flex: 1;
  padding-right: 8px;
`;

const GoalCheckmark = styled.div<{ selected: boolean }>`
  width: 14px;
  height: 14px;
  border-radius: 14px;
  border: 1px solid ${props => (props.selected ? '#4ad067' : '#949494')};
  background: ${props => (props.selected ? '#030419' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 600;
  color: #4ad067;
  flex-shrink: 0;
`;
